import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { LtiService } from '../../../../../services/lti.service';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { HtmldocModalComponent } from '@scaffold/dialogs/htmldoc-modal/htmldoc-modal.component';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';

@Component({
    selector: 'app-lti-tool',
    templateUrl: './lti-tool.component.html',
    styleUrls: ['./lti-tool.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LtiToolComponent extends BaseScaffoldComponent implements OnInit {
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private LTIService: LtiService,
    private domSanitizer: DomSanitizer,
    public dialog: ScaffoldDialogService
  ) {
    super(cdr, renderedService);
  }
  tool;
  tools;
  tool_def = {
    url: '',
    new_tab: false,
  };
  resource;
  @Input() item;
  @Output() change = new EventEmitter<any>();
  src;
  accepts = 'lti_launch_url,url,image_url';
  user = '258204';
  dialogRef: ScaffoldDialogRef;
  ngOnInit() {
    this.LTIService.getToolList()
      .pipe(take(1))
      .subscribe(tools => {
        console.log(tools);
        console.log(this.info);
        let tool_array = [];
        if (tools.id) {
          tool_array.push(tools);
        } else if (tools.listItems) {
          tool_array = tools.listItems;
        } else if (tools.push) {
          tool_array = tools;
        }
        this.tools = tool_array.filter(
          tool => tool.institution_id === this.info.institution_id
        );
        this.update();
      });
  }
  inputUpdated() {
    if (this.info.type === 'moduleitems') {
      this.change.emit({
        value: { url: this.tool_def.url },
        key: 'external_tool_settings',
      });
    } else {
      this.change.emit({ value: this.tool_def, key: this.item.name });
    }
  }

  select(t) {
    t = t?.value;
    console.log(t);
    if (t.data?.location) {
      t.data.location.forEach(loc => {
        this.resource = null;
        if (loc.location_type === 'resource_selection' && !this.resource) {
          this.resource = loc;
        }
      });
    }
    if (!this.resource) {
      this.tool_def.url = t.data.launch_url;
      if (this.info.type === 'moduleitems') {
        this.change.emit({ value: t.title, key: 'title' });
        this.change.emit({
          value: { url: this.tool_def.url },
          key: 'external_tool_settings',
        });
      } else {
        this.tool_def.url = t.data.launch_url;
        this.change.emit({ value: this.tool_def, key: this.item.name });
      }
    }
  }

  launch() {
    console.log(this.tool);
    let tool = this.tool;
    let info = this.info;
    //  this.src = "https://tuc6cdlir6.execute-api.us-east-2.amazonaws.com/dev/"
    let settings: any = {
      context: {
        data: {
          tool: tool,
          info: info,
          type: 'link',
        },
      },
    };
    this.dialogRef = this.dialog.open(HtmldocModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      console.log(result);
      if (result) {
        this.item.value = result;
        if (this.info.type === 'moduleitems') {
          this.change.emit({
            value: result.title || result.text,
            key: 'title',
          });
          this.change.emit({ value: result, key: 'external_tool_settings' });
        } else {
          this.tool_def.url = result.url;
          this.change.emit({ value: this.tool_def, key: this.item.name });
        }
        this.cdr.detectChanges();
      }
    });
  }
}
